import { Button, Layout, message, Space, Spin, Alert } from "antd";
import React, { useEffect, useState, useRef, useMemo } from "react";
import styled from "styled-components";
import {
  IconCopyDomain,
  IconWeb,
  IconMobile,
  IconTablet,
  IconLaptop,
  IconUnlink,
} from "../../../assets/icons";
import api from "../../../api/api";
import { DOMAIN_TYPE } from "../../../constants";
import InvoiceCodeModal from "./InvoiceCodeModal/InvoiceCodeModal";
import SeoInfoModal from "./SeoInfoModal/SeoInfoModal";
import ConnectDomainModal from "./ConnectDomainModal/ConnectDomainModal";
import PublishModal from "./PublishModal/PublishModal";
import UnlinkDomainModal from "./UnlinkDomainModal/UnlinkDomainModal";
import ArrowRight from "../PayHostingFee/HostingFeeOrderDetails/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import { SketchPicker } from "react-color";
import { SessionExpiredDialog } from "@components";
import { useDispatch } from "react-redux";
import { clearToken } from "@store/auth/authSlice";
import { localStorage as LocalStoreUnti } from "@utils";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
  .ant-layout {
    background: transparent;
  }

  @media (max-width: 900px) {
    .ant-layout {
    overflow-x:hidden;
    display:flex;
    justify-content:center;
    align-items:center;
      flex-direction: column !important;
    }
  }
`;
const Topbar = styled.div`
  width: 100%;
  height: 80px;
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
  flex-wrap:wrap;
  box-shadow: 0px 1px 4px 0px rgba(12, 12, 13, 0.1);
  @media (max-width: 900px){
   display: none;
  }
`;

const TopbarMobile = styled.div`
  width: 100%;
  height: 80px;
  position: sticky;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  background-color: #fff;
  flex-wrap:wrap;
  box-shadow: 0px 1px 4px 0px rgba(12, 12, 13, 0.1);
  @media (max-width: 900px){
   display: flex;
   z-index: 999;
  }
`;

const MainTitle = styled.div`
  width: 256px;
  max-width: 256px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline-start: 24px;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 20px;
  font-weight: 700;
  color: #1d1014;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(12, 12, 13, 0.1);
`;


const MobileMainTitle = styled.div`
  width: 100vw;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  padding: 0px 10px;
  z-index: 10;
  font-size: 20px;
  font-weight: 700;
  color: #1d1014;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(12, 12, 13, 0.1);
  @media (min-width: 900px){
  display: none;
  }
`;

const PagesWrapper = styled.div`
  padding-left: 24px;
  flex: 1;
  display: flex;
  gap: 4px;
  @media (max-width: 900px){
   padding: 10px 20px;
   justify-content:center;
  }
`;

const IconWrapper = styled.div`
  svg {
    cursor: pointer;
    path,
    rect {
      stroke: ${(props) =>
        props.active ? props.theme.primaryColor : "#ccc"} !important;
    }
  }
`;

const ActionsWrapper = styled.div`
  height: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  .ant-space svg {
    margin-bottom: -5px;
  }
  .ant-btn {
    min-width: 140px;
    height: 48px;
  }
  .ant-btn-default {
    color: #1d1014;
    :disabled {
      color: #b9b9b9 !important;
    }
  }
  @media (max-width: 900px) {
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 20px;
    justify-content:center;
    width: 100%;
}
`;

const ButtonText = styled.div`
  padding-right: 16px;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

const Sider = styled(Layout.Sider)`
  width: 280px !important;
  min-width: 280px !important;
  max-width: 280px !important;
  height: calc(100vh - 80px);
  overflow-y: auto;
  background: transparent;
  display:block;
  @media (max-width: 900px){
   display:none;
  }
`;

// const SiderMobile = styled(Layout.Sider)`
//   width: 280px !important;
//   min-width: 280px !important;
//   max-width: 280px !important;
//   height: calc(100vh - 80px);
//   background: transparent;
//   display:block;
//    @media (min-width: 900px){
//    display:none;
//   }
// `;

const SideContainer = styled.div`
  padding: 24px;
  @media (max-width: 900px){
  width: 100%;
  }
`;
// const SideContainerMobile = styled.div`
//   padding: 24px;
//   display:flex;
//   align-items:center;
//   width: 100%;
// `;

const ThemeTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #fff;
`;

const ThemeText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #fff;
`;

// const ColorBox = styled.div`
//   width: 30px;
//   height: 30px;
//   border-radius: 8px;
//   border: 1px solid #ccc;
//   background: ${(props) => props.color};
// `;

const ColorBox = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ color }) =>
    color ||
    "conic-gradient(from 0deg, red, orange, yellow, green, cyan, blue, violet, red)"};
  border: 1px solid #ddd;
`;

const ThemeItem = styled.div`
  margin-top: 12px;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) =>
    props.selected ? props.theme.primaryColor : "#fff"};
  cursor: pointer;
  ${ThemeTitle}, ${ThemeText} {
    color: ${(props) => (props.selected ? "#fff" : "#1D1014")};
  }
  .ant-space {
    gap: 4px !important;
  }
`;

// const ThemeItemMobile = styled.div`
//   margin-top: 12px;
//   border-radius: 8px;
//   padding: 12px;
//   display: flex;
//   gap: 12px;
//   align-items: center;
//   justify-content: flex-start;
//   cursor: pointer;
//   ${ThemeTitle}, ${ThemeText} {
//     color: ${(props) => (props.selected ? "#fff" : "#1D1014")};
//   }
//   .ant-space {
//     gap: 4px !important;
//   }
// `;


const Content = styled(Layout.Content)`
  height: calc(100vh - 80px);
  background-color: #fff;
  display: block;

  @media (max-width: 900px) {
    display: none;
  }
`;
const ContentMobile = styled.div`
  height: calc(100vh - 80px);
  background-color: #fff;
  display: none;

  @media (max-width: 900px) {
    display: block;
  }
`;

const Bar = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #b9e2ff;
  svg {
    margin-top: -1px;
    cursor: pointer;
  }
    @media (max-width: 900px){
    width: 100vw;
    }
`;

const Text = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #1d1014;
`;

const TitleText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1d1014;
`;
const BoldText = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

const IFrame = styled.iframe`
  width: ${(props) =>
    props.view_size === "mobile"
      ? "370px"
      : props.view_size === "tablet"
      ? "474px"
      : "100%"};
  height: 100%;
  border: none;
  margin: 0 auto;
  display: ${(props) => (props.loaded ? "block" : "none")};
`;

const IFrameWrapper = styled.div`
  width: 100%;
  height: calc(100% - 53px);
  text-align: center;
  position: relative;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  z-index: 10;
`;

const ErrorOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  max-width: 90%;
  z-index: 10;
`;

const RetryButton = styled(Button)`
  margin-top: 12px;
`;

const SiderMobile = styled.div`
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  background: transparent;
  display: block;
  overflow-x: auto;
  height: auto;
  @media (min-width: 900px) {
    display: none;
  }

  /* hide scrollbar */
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const SideContainerMobile = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  width: max-content;
  gap: 12px;
`;

const ThemeItemMobile = styled.div`
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${(props) =>
    props.selected ? props.theme.primaryColor : "#fff"};
  border: ${(props) =>
    props.selected
      ? `2px solid ${props.theme.primaryColor}`
      : "1px solid #E5E5E5"};

  transition: all 0.2s ease;

  .ant-space {
    margin: 0 !important;
  }
`;

const ThemeSeparator = styled.div`
  width: 1px;
  height: 32px;
  background: #d9d9d9;
  margin: 0 4px;
  flex-shrink: 0;
`;


const MOBILE_LK = "mobile";
const TABLET_LK = "tablet";
const LAPTOP_LK = "laptop";

const LANGUAGE_MAP = {
  English: "en",
  Myanmar: "my",
  Chinese: "zh",
};


const EditTemplate = () => {
  const [loading, setLoading] = useState(true);
  const [themeLoading, setThemeLoading] = useState(false);
  const [store_status, setStoreStatus] = useState(null);
  const [domain_status_data, setDomainStatusData] = useState(null);
  const [themes, setThemes] = useState([]);
  const [seo_info, setSeoInfo] = useState(null);
  const [short_code, setShortCode] = useState("");
  // const [available_domains, setAvailableDomains] = useState([]);
  const [hosting_fee, setHostingFee] = useState({});
  const [selected_theme, setSelectedTheme] = useState(null);
  const [selected_view, setSelectedView] = useState(MOBILE_LK);

  // Iframe loading states
  const [iframeLoading, setIframeLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [currentIframeUrl, setCurrentIframeUrl] = useState("");
  const iframeRef = useRef(null);
  const retryTimeoutRef = useRef(null);
  const maxRetries = 3;
  const retryDelay = 5000;

  // Show loading UI for 15 seconds after domain connect
  const [pendingDomainConnect, setPendingDomainConnect] = useState(false);

  const [openInvoiceCodeModal, setOpenInvoiceCodeModal] = useState(false);
  const [openSeoModal, setOpenSeoModal] = useState(false);
  const [openDomainModal, setOpenDomainModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [openUnlinkModal, setOpenUnlinkModal] = useState(false);
//custom color
const [customTheme, setCustomTheme] = useState(null);
const [customPrimary, setCustomPrimary] = useState("");
const [customPrimaryDark, setCustomPrimaryDark] = useState("");
const [showColorPicker, setShowColorPicker] = useState(false);
const [colorRefresh, setColorRefresh] = useState(false);
const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 5,
    totalCount: 0,
  });

  const {t} = useTranslation();
  const [langData,setLangData] = useState();
  const [langCode, setLangCode] = useState("en");

  
useEffect(() => {
  if (themes && themes.length > 0) {
    // Find existing custom theme in API data
    const foundCustom = themes.find((t) => t.is_custom);

    if (foundCustom) {
      setCustomTheme(foundCustom);
      setCustomPrimary(foundCustom.colors?.theme_color || "");
      setCustomPrimaryDark(foundCustom.colors?.theme_color_dark || "");
    } else {
      // If not found, set default custom theme
      setCustomTheme({
        id: "custom",
        is_custom: true,
        colors: {
          theme_name: "Custom Theme",
          theme_description: t('pick_your_own_color'),
          theme_color: "",
          theme_color_dark: "",
        },
      });
    }
  }
}, [themes]);



 const [domainLoading, setDomainLoading] = useState(false);
const navigate = useNavigate();

useEffect(() => {
  if (pendingDomainConnect) {
    const timeout = setTimeout(() => {
      setPendingDomainConnect(false);
    }, 15000); // 15 seconds

    return () => clearTimeout(timeout);
  }
}, [pendingDomainConnect]);

useEffect(() => {
  const stored = localStorage.getItem("domainConnectExpireAt");

  if (stored) {
    const expireAt = parseInt(stored, 10);
    const now = Date.now();

    if (expireAt > now) {
      setDomainLoading(true);

      const timeout = setTimeout(() => {
        window.location.reload();
        setDomainLoading(false);
        localStorage.removeItem("domainConnectExpireAt");
      }, expireAt - now);

      return () => clearTimeout(timeout);
    } else {
      localStorage.removeItem("domainConnectExpireAt");
    }
  }
}, []);

  // Handle domain connect success
  const handleConnectDomainSuccess = (updated_data) => {
    setDomainStatusData(updated_data);
    getAvailableDomains(pagination.page);
    setOpenDomainModal(false);
    getConnectedDomains();
    // Immediately show "Connecting..." message
    setPendingDomainConnect(true);

    // Optional: set localStorage so reload keeps state (not required anymore)
    const expireAt = Date.now() + 15000;
    localStorage.setItem("domainConnectExpireAt", expireAt.toString());
  };

  // Check domain status
  const checkDomainStatus = () => {
    api
      .checkDomainStatus()
      .then(({ data, store }) => {
        setDomainStatusData(data);
        setStoreStatus(store?.status);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  // Handle unlink
  const handleUnlinkClicked = () => {
    if (domain_status_data?.domain_name) {
      setOpenUnlinkModal(true);
    }
  };

  const onConfirmUnlink = () => {
    api
      .unlinkDomain()
      .then(() => {
        setDomainStatusData(null);
        message.success("Domain unlinked successfully!");
        checkDomainStatus();
        getAvailableDomains(pagination.page);
        getConnectedDomains();
      })
      .catch((error) => {
        message.error(error);
      });
  };

  // Iframe handlers
  const handleIframeLoad = () => {
    setIframeLoading(false);
    setIframeError(false);
    setIframeLoaded(true);
    setRetryCount(0);
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
      retryTimeoutRef.current = null;
    }
  };

  const handleIframeError = () => {
    setIframeLoading(false);
    setIframeLoaded(false);
    if (retryCount < maxRetries) {
      setIframeError(false);
      retryTimeoutRef.current = setTimeout(() => {
        setRetryCount((prev) => prev + 1);
        setIframeLoading(true);
        reloadIframe();
      }, retryDelay);
    } else {
      setIframeError(true);
    }
  };

  const reloadIframe = () => {
    if (iframeRef.current && currentIframeUrl) {
      const urlWithTimestamp = `${currentIframeUrl}&t=${Date.now()}`;
      iframeRef.current.src = urlWithTimestamp;
    }
  };

  const handleManualRetry = () => {
    setRetryCount(0);
    setIframeError(false);
    setIframeLoading(true);
    setIframeLoaded(false);
    reloadIframe();
  };

  const resetIframeState = () => {
    setIframeLoading(true);
    setIframeError(false);
    setIframeLoaded(false);
    setRetryCount(0);
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
    }
  };

  // Initial load
  useEffect(() => {
    checkDomainStatus();
    getTemplateThemes();
    getStoreSeo();
    checkInvoiceShortCode();
    getAvailableDomains();
    getConnectedDomains();
    checkHostingFee();
    getPanelInfo();

    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, []);

  // Reset iframe when URL changes
  useEffect(() => {
    const newUrl = getPreviewUrl();
    if (newUrl && newUrl !== currentIframeUrl) {
      setCurrentIframeUrl(newUrl);
      resetIframeState();
    }
  }, [domain_status_data]);

  useEffect(() => {
    resetIframeState();
  },[colorRefresh])

  // Data fetching functions
  const getTemplateThemes = () => {
    api
      .getTemplateThemes()
      .then(({ data }) => {
        setThemes(data.availableThemes);
        setSelectedTheme(data.availableThemes.find((t) => t.selected));
      })
      .catch((error) => {
        message.error(error);
      });
  };

  // const updateTemplateTheme = () => {
  //   if (!selected_theme || themeLoading) return;
  //   setThemeLoading(true);
  //   api
  //     .updateTemplateTheme({ theme_id: selected_theme.id })
  //     .then(() => {
  //       setThemeLoading(false);
  //       message.success("Theme saved successfully!");
  //       reloadIframe();
  //     })
  //     .catch((error) => {
  //       setThemeLoading(false);
  //       message.error(error);
  //     });
  // };

  const updateTemplateTheme = () => {
  if (!selected_theme || themeLoading) return;

  setThemeLoading(true);
  // Check if selected theme is a custom one
  const payload = (selected_theme?.id === "custom" || selected_theme?.is_custom === true)
    ? {
        colors: {
          theme_name:
            selected_theme.colors.theme_name || "Custom Theme",
          theme_color: selected_theme.colors.theme_color,
          theme_description:
            selected_theme.colors.theme_description || "",
        },
      }
    : { theme_id: selected_theme.id };

  api
    .updateTemplateTheme(payload)
    .then(() => {
      setThemeLoading(false);
      message.success(t('theme_saved_success'));
     if (selected_theme?.isCustom) {
        window.location.reload();
    } else {
      // reloadIframe();
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
    })
    .catch((error) => {
      setThemeLoading(false);
      message.error(error?.message || t('fail_update_theme'));
    });
};

  const getStoreSeo = () => {
    api
      .getStoreSeo()
      .then(({ data }) => {
        setSeoInfo(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const checkInvoiceShortCode = () => {
    api
      .checkInvoiceShortCode()
      .then(({ data: { short_code } }) => {
        setShortCode(short_code);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  // const getAvailableDomains = () => {
  //   api
  //     .getAvailableDomains()
  //     .then(({ data: { domain_records } }) => {
  //       setAvailableDomains(domain_records);
  //     })
  //     .catch((error) => {
  //       message.error(error);
  //     });
  // };

   const getAvailableDomains = (page = 1) => {
    setLoading(true);
    api
      .getAvailableDomains({ page, page_size: pagination.pageSize })
      .then(({ data: { domain_records, pagination: pag } }) => {
        setPagination({
          page: pag.page,
          pageSize: pag.pageSize,
          totalCount: pag.totalCount,
        });
      })
      .catch((err) => message.error(err))
      .finally(() => setLoading(false));
  };

  const [connectedDomain, setConnectedDomain] = useState(null);

  const getConnectedDomains = () => {
    api
      .getConnectedDomains()
      .then(({ data }) => {
        setConnectedDomain(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const checkHostingFee = (custom_domain) => {
    api
      .checkHostingFee({ custom_domain })
      .then(({ data }) => {
        setHostingFee({
          toPay: data.toPay,
          amount: data.hostingFees?.amount,
        });
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const isReadyToPublish = () => {
    if (!selected_theme) {
      message.warning(t('plz_select_theme'));
      return false;
    } else if (!short_code) {
      setOpenInvoiceCodeModal(true);
      return false;
    } else if (
      !seo_info?.seo_title ||
      !seo_info?.seo_description ||
      !seo_info?.image
    ) {
      message.warning(t('add_seo_first'));
      return false;
    } else if (domain_status_data?.domain_type !== DOMAIN_TYPE.CUSTOM) {
      message.warning(t('plz_connect_domain'));
      return false;
    }
    return true;
  };

  const handlePublishClicked = () => {
    if (!isReadyToPublish()) return;
    setOpenPublishModal(true);
  };

  const handleSeoInfoClicked = () => {
    setOpenSeoModal(true);
  };

  const handleShortCodeSuccess = (code) => {
    setShortCode(code);
  };

  const handleSeoSuccess = ({ seo_image_url, ...info }) => {
    setSeoInfo({
      ...info,
      image: seo_image_url,
    });
  };

  const handleDomainNameClicked = () => {
    if (checkIfCanPublish()) {
      handleConnectDomainClicked();
      return;
    }
    window.open(domain_status_data?.domain_name);
  };

  const handleConnectDomainClicked = () => {
    setOpenDomainModal(true);
  };

  const checkIfCanPublish = () => {
    return store_status === "DRAFT" || store_status === "UNPUBLISHED";
  };

  

  const getPanelInfo = () => {
  api
    .getPanelInfo()
    .then(({ data }) => {
      setLangData(data);

      const languageName = data?.storeLanguages?.[0]?.language;
      setLangCode(LANGUAGE_MAP[languageName] ?? "en");
    })
    .catch((error) => {
      message.error(error);
    });
};

  const getPreviewUrl = () => {
    if (!domain_status_data) return "";
    const themeColor =
      selected_theme?.colors?.theme_color?.replace("#", "") || "default";
    try {
      return `${
        domain_status_data.domain_name
      }/${langCode}?theme=${themeColor}&t=${Date.now()}`;
    } catch (err) {
      console.error("Error building preview URL:", err);
      return "";
    }
  };

  const view_sizes = [
    { key: MOBILE_LK, icon: <IconMobile /> },
    { key: TABLET_LK, icon: <IconTablet /> },
    { key: LAPTOP_LK, icon: <IconLaptop /> },
  ];

  const generateDarkColor = (hex) => {
  try {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = Math.max((num >> 16) - 100, 0);
    const g = Math.max(((num >> 8) & 0x00ff) - 100, 0);
    const b = Math.max((num & 0x0000ff) - 100, 0);
    return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, "0")}`;
  } catch {
    return "#000000";
  }
};


  const renderIframeContent = () => {
    // Phase 1: Show loading message for 15 seconds after domain connect
    if (pendingDomainConnect) {
      return (
        <LoadingOverlay>
          <Spin size="large" />
          <div>{t('connecting_domain')}</div>
          <div style={{ fontSize: "12px", color: "#666", textAlign: "center" }}>
            {t('domain_take_time')}
          </div>
        </LoadingOverlay>
      );
    }
    // Phase 2: After 15 seconds, try loading the preview
    const previewUrl = getPreviewUrl();
    if (!previewUrl) {
      return (
        <LoadingOverlay>
          <Alert
            style={{display:"flex", alignItems:"start",justifyContent:"start",textAlign:"start"}}
            message={t('no_preview_available')}
            description={t('connect_domain_to_see_preview')}
            type="info"
            showIcon
          />
        </LoadingOverlay>
      );
    }

    return (
      <>
        {iframeLoading && !iframeError && (
          <LoadingOverlay>
            <Spin size="large" />
            <div>{t('loading_preview')}</div>
            <div
              style={{ fontSize: "12px", color: "#666", textAlign: "center" }}
            >
              {t('custom_domain_take_few_min')}
            </div>
          </LoadingOverlay>
        )}

        {iframeError && (
          <ErrorOverlay>
            <Alert
              message={t('preview_unavailable')}
              description={t('unable_to_load')}
              type="warning"
              showIcon
              action={
                <RetryButton
                  type="primary"
                  size="small"
                  onClick={handleManualRetry}
                >
                  {t('retry_now')}
                </RetryButton>
              }
            />
          </ErrorOverlay>
        )}

        <IFrame
          ref={iframeRef}
          src={previewUrl}
          view_size={selected_view}
          loaded={iframeLoaded}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
        />
      </>
    );
  };

   const dispatch = useDispatch();
  
    const resetSessionState = () => {
      // clear token in redux
      dispatch(clearToken());
      // remove token from localstorage
      LocalStoreUnti.clearToken();
      // update token in request obj
      api.setSessionToken("");
  
      // remove admin from localstorage
      LocalStoreUnti.clearAdmin();

      navigate("/login")
    };

  return (
    <RootContainer>
      <TopbarMobile>
      <MobileMainTitle>
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"10px"}}>
          <div onClick={() => navigate("/home/template-management/template")} style={{display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"6px",cursor:"pointer"}}>
          <img
            src={ArrowRight}
            alt="Arrow"
            width={15}
            height={15}
            style={{ transform: "rotate(180deg)",border:"1px solid #cecece", padding:"3px 12px",borderRadius:"5px" }}
          />
        </div>
        <div style={{display:"flex",flexDirection:"column",alignItems:"start"}}>
         
        <p style={{fontSize:"14px"}}>
          {t('template_editor')}
          </p>
          <Space style={{whiteSpace:"nowrap",display:"flex",alignItems:"center"}} onClick={handleSeoInfoClicked}>
            <ButtonText>{t('edit_seo_info')}</ButtonText>
          </Space>
          </div>
          </div>
           <div style={{display:"flex", alignItems:"center",gap:"10px"}}>
          <Button
            type="default"
            disabled={!selected_theme}
            loading={themeLoading}
            onClick={updateTemplateTheme}
            style={{fontSize:"14px",padding:"20px 10px"}}
          >
           {t('save_theme')}
          </Button>
          <Button
            type="primary"
            disabled={!checkIfCanPublish()}
            onClick={handlePublishClicked}
            style={{fontSize:"14px",padding:"20px 10px"}}
          >
            {t('step_5_title')}
          </Button>
          </div>
        </MobileMainTitle>
      </TopbarMobile>
      <Topbar>
        <MainTitle>
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"10px",width:"100%",marginLeft:"-20px"}}>
          <div onClick={() => navigate("/home/template-management/template")} style={{display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"6px",cursor:"pointer"}}>
          <img
            src={ArrowRight}
            alt="Arrow"
            width={30}
            height={30}
            style={{ transform: "rotate(180deg)",border:"1px solid #cecece", padding:"3px 12px",borderRadius:"5px" }}
          />
        </div>
          {t('template_editor')}
          </div>
        </MainTitle>
        <PagesWrapper>
          {view_sizes.map((item, key) => (
            <IconWrapper
              key={key}
              active={item.key === selected_view ? 1 : 0}
              onClick={() => setSelectedView(item.key)}
            >
              {item.icon}
            </IconWrapper>
          ))}
        </PagesWrapper>
        <ActionsWrapper>
          <Space style={{whiteSpace:"nowrap"}} onClick={handleSeoInfoClicked}>
            <IconWeb />
            <ButtonText>{t('edit_seo_info')}</ButtonText>
          </Space>
          <div style={{display:"flex", alignItems:"center",gap:"10px"}}>
          <Button
            type="default"
            disabled={!selected_theme}
            loading={themeLoading}
            onClick={updateTemplateTheme}
          >
           {t('save_theme')}
          </Button>
          <Button
            type="primary"
            disabled={!checkIfCanPublish()}
            onClick={handlePublishClicked}
          >
            {t('step_5_title')}
          </Button>
          </div>
        </ActionsWrapper>
      </Topbar>

      <Layout>
        {/* <Sider>
          <SideContainer>
            <Text>Change Theme Color</Text>
            {themes.map((theme, key) => (
              <ThemeItem
                key={key}
                selected={theme.id === selected_theme?.id ? 1 : 0}
                onClick={() => setSelectedTheme(theme)}
              >
                <div style={{ flex: 1 }}>
                  <ThemeTitle>{theme.colors.theme_name}</ThemeTitle>
                  <ThemeText>{theme.colors.theme_description}</ThemeText>
                </div>
                <Space>
                  <ColorBox color={theme.colors.theme_color} />
                </Space>
              </ThemeItem>
            ))}
          </SideContainer>
        </Sider> */}

  <Sider>
  <SideContainer>
    <TitleText>{t('custom_theme_color')}</TitleText>
    {/* --- Custom Theme at Top --- */}
    <div>
      <ThemeItem
        selected={selected_theme?.isCustom ? 1 : 0}
        onClick={() => {
    // Set selectedTheme to custom without refreshing iframe
    if (!selected_theme?.isCustom) {
      const customData = {
        id: customTheme?.id || "custom",
        isCustom: true,
        colors: {
          theme_name: "Custom Theme",
          theme_description: "Your personalized color scheme",
          theme_color: customPrimary || "#cccccc",
          theme_color_dark: customPrimaryDark || "#888888",
        },
      };
      setSelectedTheme(customData); // Only sets theme, iframe will refresh if color changes
    }
    // Toggle color picker visibility
    setShowColorPicker((prev) => !prev);
  }}
        style={{ marginBottom: "16px" }}
      >
        <div style={{ flex: 1 }}>
          <ThemeTitle>{t('pick_your_own_color')}</ThemeTitle>
          {/* <ThemeText>
            {customPrimary
              ? "Your personalized color scheme"
              : "Pick your own colors"}
          </ThemeText> */}
        </div>
        <Space>
          {/* <ColorBox color={customPrimary || "#f0f0f0"} /> */}

          <ColorBox
            color={
              "conic-gradient(from 0deg, red, orange, yellow, green, cyan, blue, violet, red)"
               
            }
          />
        </Space>
      </ThemeItem>

      {/* --- Color Picker appears only when Custom Theme is active --- */}
      {selected_theme?.isCustom && (
        <div
          style={{
            background: "#fff",
            padding: "12px",
            borderRadius: "8px",
            boxShadow: "0 0 6px rgba(0,0,0,0.1)",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
             <Space><ColorBox color={customPrimary || "#f0f0f0"} /> </Space>
            <Button
              size="small"
              onClick={() => setShowColorPicker(!showColorPicker)}
            >
              {showColorPicker ? t('close_picker') : t('choose_color')}
            </Button>
          </div>

          {showColorPicker && (
            <div style={{ marginTop: "12px" }}>
              <SketchPicker
                color={customPrimary || "#ffffff"}
                onChangeComplete={(color) => {
                  const newPrimary = color.hex;
                  setColorRefresh(!colorRefresh)
                   if (newPrimary === customPrimary) return;
                  const dark = generateDarkColor(newPrimary);

                  const updatedCustom = {
                    id: "custom",
                    isCustom: true,
                    colors: {
                      theme_name: "Custom Theme",
                      theme_description: "Your personalized color scheme",
                      theme_color: newPrimary,
                      theme_color_dark: dark,
                    },
                  };

                  setCustomPrimary(newPrimary);
                  setCustomPrimaryDark(dark);
                  setCustomTheme(updatedCustom);
                   setSelectedTheme(updatedCustom);
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  <TitleText>{t('default_theme_color')}</TitleText>
    {/* --- Default Themes Below --- */}
    {themes.map((theme, key) => (
      <ThemeItem
        key={key}
        selected={!selected_theme?.isCustom && theme.id === selected_theme?.id ? 1 : 0}
        onClick={() => {
          setSelectedTheme(theme)
          setColorRefresh(!colorRefresh)
        }
        }
      >
        <div style={{ flex: 1 }}>
          <ThemeTitle>{theme.colors.theme_name}</ThemeTitle>
          <ThemeText>{theme.colors.theme_description}</ThemeText>
        </div>
        <Space>
          <ColorBox color={theme.colors.theme_color} />
        </Space>
      </ThemeItem>
    ))}
  </SideContainer>
</Sider>

<SiderMobile>
  <SideContainerMobile>
    {/* CUSTOM COLOR */}
    <div>
      <ThemeItemMobile
        selected={selected_theme?.isCustom ? 1 : 0}
        onClick={() => {
          if (!selected_theme?.isCustom) {
            const customData = {
              id: customTheme?.id || "custom",
              isCustom: true,
              colors: {
                theme_color: customPrimary || "#cccccc",
                theme_color_dark: customPrimaryDark || "#888888",
              },
            };

            setSelectedTheme(customData);
          }

          setShowColorPicker((prev) => !prev);
        }}
      >
        <ColorBox
          color={
            "conic-gradient(from 0deg, red, orange, yellow, green, cyan, blue, violet, red)"
          }
        />
      </ThemeItemMobile>

      {selected_theme?.isCustom && showColorPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            marginTop: "12px",
          }}
        >
          <SketchPicker
            color={customPrimary || "#ffffff"}
            onChangeComplete={(color) => {
              const newPrimary = color.hex;

              if (newPrimary === customPrimary) return;

              setColorRefresh(!colorRefresh);

              const dark = generateDarkColor(newPrimary);

              const updatedCustom = {
                id: "custom",
                isCustom: true,
                colors: {
                  theme_color: newPrimary,
                  theme_color_dark: dark,
                },
              };

              setCustomPrimary(newPrimary);
              setCustomPrimaryDark(dark);
              setCustomTheme(updatedCustom);
              setSelectedTheme(updatedCustom);
            }}
          />
        </div>
      )}
    </div>

    {/* SEPARATOR */}
    <ThemeSeparator />

    {/* DEFAULT COLORS */}
    {themes.map((theme, key) => (
      <ThemeItemMobile
        key={key}
        selected={
          !selected_theme?.isCustom &&
          theme.id === selected_theme?.id
            ? 1
            : 0
        }
        onClick={() => {
          setSelectedTheme(theme);
          setColorRefresh(!colorRefresh);
        }}
      >
        <ColorBox color={theme.colors.theme_color} />
      </ThemeItemMobile>
    ))}
  </SideContainerMobile>
</SiderMobile>


        <Content>
          <Bar>
            {domain_status_data?.domain_type !== DOMAIN_TYPE.CUSTOM ? (
              <>
                <Text>{t('to_publish')} </Text>
                <BoldText onClick={handleConnectDomainClicked}>
                  {t('connect_domain')}
                </BoldText>
              </>
            ) : (
              <>
                <Text>{t('connect_domain_link')}: </Text>
                <BoldText onClick={handleDomainNameClicked}>
                  {domain_status_data?.domain_name}
                </BoldText>
                <IconCopyDomain
                  onClick={() =>
                    navigator.clipboard
                      .writeText(domain_status_data?.domain_name)
                      .then(() => message.success("Copied!"))
                  }
                />
                <IconUnlink onClick={handleUnlinkClicked} />
              </>
            )}
          </Bar>
          <IFrameWrapper>
            {useMemo(
              () => renderIframeContent(),
              [
                pendingDomainConnect,
                domain_status_data,
                selected_view,
                iframeLoading,
                iframeError,
                iframeLoaded,
                retryCount,
                currentIframeUrl,
              ]
            )}
          </IFrameWrapper>
        </Content>
        <ContentMobile>
           <Bar>
            {domain_status_data?.domain_type !== DOMAIN_TYPE.CUSTOM ? (
              <>
                <Text>{t('to_publish')} </Text>
                <BoldText onClick={handleConnectDomainClicked}>
                  {t('connect_domain')}
                </BoldText>
              </>
            ) : (
              <>
                <Text>{t('connect_domain_link')}: </Text>
                <BoldText onClick={handleDomainNameClicked}>
                  {domain_status_data?.domain_name}
                </BoldText>
                <IconCopyDomain
                  onClick={() =>
                    navigator.clipboard
                      .writeText(domain_status_data?.domain_name)
                      .then(() => message.success("Copied!"))
                  }
                />
                <IconUnlink onClick={handleUnlinkClicked} />
              </>
            )}
          </Bar>
          <IFrameWrapper>
            {useMemo(
              () => renderIframeContent(),
              [
                pendingDomainConnect,
                domain_status_data,
                selected_view,
                iframeLoading,
                iframeError,
                iframeLoaded,
                retryCount,
                currentIframeUrl,
              ]
            )}
          </IFrameWrapper>
        </ContentMobile>
      </Layout>

      <InvoiceCodeModal
        open={openInvoiceCodeModal}
        handleClose={() => setOpenInvoiceCodeModal(false)}
        successCallback={handleShortCodeSuccess}
      />
      <SeoInfoModal
        data={seo_info}
        open={openSeoModal}
        handleClose={() => setOpenSeoModal(false)}
        successCallback={handleSeoSuccess}
      />
      <ConnectDomainModal
        isNew={domain_status_data?.domain_type !== DOMAIN_TYPE.CUSTOM}
        // available_domains={available_domains}
        connectedDomainData={connectedDomain}
        open={openDomainModal}
        handleClose={() => setOpenDomainModal(false)}
        successCallback={handleConnectDomainSuccess}
      />
      <PublishModal
        seo_info={seo_info}
        hosting_fee={hosting_fee}
        domain_name={domain_status_data?.domain_name}
        open={openPublishModal}
        handleClose={() => {
          setOpenPublishModal(false);
          checkDomainStatus();
        }}
      />
      <UnlinkDomainModal
        open={openUnlinkModal}
        onClose={() => setOpenUnlinkModal(false)}
        onConfirm={onConfirmUnlink}
        domainName={domain_status_data?.domain_name}
      />
      <SessionExpiredDialog handleClick={resetSessionState} />
    </RootContainer>
  );
};

export default EditTemplate;
